module.exports = "<div class=\"input-field col s3\"\n  ng-form=\"idForm\"\n  ng-class=\"{\n    error: idForm.id.$error && idForm.id.$dirty,\n    success: idForm.id.$valid && myId\n  }\">\n  <input id=\"id\"\n    name=\"id\"\n    type=\"tel\"\n    class=\"center-input\"\n    next\n    indextab=\"{{myIndex}}\"\n    minlength=\"{{myLength}}\"\n    maxlength=\"{{myLength}}\"\n    ng-model=\"myId\"\n    placeholder=\"{{$root.labels.wagon.fields.id.text}}\" />\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/entities/trains/wagon/directives/inputs/myWagonPartId.html
// module id = 1119
// module chunks = 0